
import React from "react";

/**
 * Share Data Context
 */

interface SharedData {
    eventListPage: {
        filters: any
    },
    pruListPage: {
        filters: any
    },
    envListPage: {
        filters: any
    },
    mapViewerPage: {
        mapEditMode: boolean,
        isEditing: boolean,
        isDrawing: boolean,
    }
}

const initSharedData: SharedData = {
    eventListPage: {
        filters: {
            page: 1,
            size: 10,
        }
    },
    pruListPage: {
        filters: {
            page: 1,
            size: 8,
        }
    },
    envListPage: {
        filters: {
            page: 1,
            size: 10,
        }
    },
    mapViewerPage: {
        mapEditMode: false,
        isEditing: false,
        isDrawing: false,
    }
}

interface SharedContextProps {
    sharedData: SharedData,
    setSharedData: React.Dispatch<React.SetStateAction<SharedData>>,
    setInitialSharedData: () => void,
}

export const SharedContext = React.createContext<SharedContextProps>(undefined!);

export function useSharedContext(): SharedContextProps {
const context = React.useContext(SharedContext);
    if (!context) {
        throw new Error('SharedContextProvider component must be rendered as child of SharedContextProvider component');
    }
    return context;
}

const SharedContextProvider = (props: { children: React.ReactNode; }) => {
    const [sharedData, setSharedData] = React.useState<SharedData>(initSharedData);
    
    const setInitialSharedData = () => {
        setSharedData(JSON.parse(JSON.stringify(initSharedData)));
    }

    return (
        <SharedContext value={{ sharedData: sharedData, setSharedData: setSharedData, setInitialSharedData }}>
            {props.children}
        </SharedContext>
    );
};

export default SharedContextProvider;
